import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue-main',
  templateUrl: './issue-main.component.html'
})
export class IssueMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/issues/components/issue-main.component.ts